import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useAppSelector } from '../../../redux/hooks';
import { rootState } from '../../../redux/store';
import { RedirectPage } from './RedirectPage';

interface IPrivateRouteProps {
    redirectTime: number;
    redirectRoute: string;
    isLoggedIn: boolean;
    title: string;
}

export const PrivateRoute: React.FC<IPrivateRouteProps> = ({ redirectTime, redirectRoute, isLoggedIn, title }) => {
    const { userAndTokenData } = useAppSelector((state: rootState) => state.loginUserAndTokenData);
    const [isNull, setIsNull] = useState<boolean | undefined>(undefined);

    useEffect(() => {
        if (userAndTokenData !== undefined) {
            setIsNull(!userAndTokenData);
        }
    }, [userAndTokenData]);

    if (isNull === undefined) {
        return null;
    }

    return <>{isLoggedIn === isNull ? <Outlet /> : <RedirectPage redirectTime={redirectTime} redirectRoute={redirectRoute} title={title} isLoggedIn={isLoggedIn} custom={false} />}</>;
};
